import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AppContext } from '../contexts/app.context';
import { Text } from '../components';
import { ArrowRightIcon } from '../assets/icons';

const Home = () => {
  const { t } = useTranslation();
  const { setBaseContainerConfig } = useContext(AppContext);

  useEffect(() => {
    setBaseContainerConfig({
      heading: '',
      subHeading: '',
      buttonText: t('loginButtonText'),
      buttonURL: '/login',
    });
  }, []);

  return (
    <div className="min-h-[40dvh]">
      <div className="text-center">
        <Text type={'big'} text={t('home.heading')} />
        <Text type={'small'} text={t('home.subHeading')} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-12">
        <div className="bg-lightBlue-10 border border-gray-80 rounded-lg p-8 h-full relative">
          <Text
            type={'small'}
            text={t('home.schools.heading')}
            className={'font-bold text-gray-10'}
          />
          <div className="flex flex-row items-center justify-between gap-2 mt-2">
            <Text
              type={'xsmall'}
              text={t('home.schools.subHeading')}
              className={'text-gray-10 w-11/12'}
            />
          </div>
          <Link to={'/form/schools'} className="cursor-pointer">
            <ArrowRightIcon
              className={
                'text-gray-10 bg-gray-40 rounded-full p-2 w-1/12 absolute right-4 top-1/2 -translate-y-1/2'
              }
            />
          </Link>
        </div>

        <div className="bg-lightBlue-10 border border-gray-80 rounded-lg p-8 h-full relative">
          <Text
            type={'small'}
            text={t('home.otherGroups.heading')}
            className={'font-bold text-gray-10'}
          />
          <div className="flex flex-row items-center justify-between gap-2 mt-2">
            <Text
              type={'xsmall'}
              text={t('home.otherGroups.subHeading')}
              className={'text-gray-10 w-11/12'}
            />
          </div>
          <Link to={'/form/other-groups'} className="cursor-pointer">
            <ArrowRightIcon
              className={
                'text-gray-10 bg-gray-40 rounded-full p-2 w-1/12 absolute right-4 top-1/2 -translate-y-1/2'
              }
            />
          </Link>
        </div>

        {/* <div className="bg-gray-90 border border-gray-80 rounded-lg p-8 h-full relative">
          <Text
            type={'small'}
            text={t('home.transport.info.heading')}
            className={'font-bold text-gray-10'}
          />
          <div className="mt-2">
            <Text
              type={'xsmall'}
              text={t('home.transport.info.subHeading')}
              className={'text-gray-10'}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Home;
